export default "__VITE_PUBLIC_ASSET__de1c22ed__"